import { useLocation } from "react-router-dom";
import { trackEvent } from "../../services/tracking";

const WHATSAPP_URL =
  "https://wa.me/5511987790294?text=Olá!%20Gostaria%20de%20solicitar%20um%20orçamento";

export default function FloatingWhatsApp() {
  const location = useLocation();

  const handleClick = () => {
    trackEvent("whatsapp_click", {
      origem: "botao_flutuante",
      pagina: location.pathname,
    });
  };

  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      aria-label="Falar no WhatsApp"
      className="fixed right-6 bottom-6 z-[60] flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-all hover:scale-105 hover:bg-[#1fb855] hover:shadow-xl cursor-pointer"
    >
      <i className="ri-whatsapp-line text-3xl w-8 h-8 flex items-center justify-center"></i>
    </a>
  );
}
